const template = require('./product-name.html');

export default function ProductNameDirective() {
  return {
    template,
    restrict: 'E',
    require: '^^form',
    scope: {
      newProduct: '=',
      masterVendorId: '<',
      masterProducts: '<'
    },
    link(scope, el, attrs, form) { // eslint-disable-line no-unused-vars
      scope.selectedMasterProduct = {
        masterProductId: scope.newProduct.masterProductId || ''
      };
      scope.form = form;

      scope.changeSelection = (selectedMasterProduct) => {
        if (!selectedMasterProduct) {
          // The select is initializing, so don't change the viewmodel
          return;
        }
        scope.newProduct.masterProductId = selectedMasterProduct.masterProductId || -1;
        scope.newProduct.name = selectedMasterProduct.name || '';
      };

      scope.returnToMasterProductList = () => {
        scope.newProduct.masterProductId = null;
        scope.newProduct.name = null;
      };
    },
    replace: true,
  };
}
